import React from "react";
import "../../styles/SalesFunnel.css";
import awareness from "../../assets/icons/front-end.png";
import conversion from "../../assets/icons/web-programming.png";
import retention from "../../assets/icons/responsive.png";
import analytics from "../../assets/icons/ecommerce.png";
import testing from "../../assets/icons/cms.png";
import optimization from "../../assets/icons/optimize.png";

const UIservice = () => {
  return (
    <div className="sf-services">
      <h3>Web Design Services We Offer</h3>
      <p className="sf-description">
       We offer professional web design services including responsive websites, eCommerce solutions, UI/UX design, landing pages, website redesign, and maintenanc
      </p>

      <div className="sf-cards-wrapper">
        <div className="sf-service-card">
          <div className="sf-icon">
            <img className="icon-img" src={awareness} alt="Awareness Stage" />
          </div>
          <h3>Custom Web Design Services</h3>
          <p>
            We focus on smooth layouts, consumer-pleasant structures, and tasty
            visuals that beautify purchaser studies. As a dependable{" "}
            <b>website design company</b>, we make sure every venture is
            developed with scalability and future growth in thoughts.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={conversion}
              alt="Conversion Optimization"
            />
          </div>
          <h3>Responsive Web Design Solutions</h3>
          <p>
            A responsive internet site automatically adjusts to distinctive
            display screen sizes and devices, offering a unbroken consumer
            experience. Our <b>responsive web design</b> answers ensure your
            website plays perfectly on: Smartphones , Tablets , Laptops ,
            Desktop , computer systems
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={retention}
              alt="Customer Retention"
            />
          </div>
          <h3>E-Commerce Website Development</h3>
          <p>
            Online buying keeps to develop hastily, making it important for
            agencies to put money into professional eCommerce solutions. Our{" "}
            <b>ecommerce website design</b> services consist of: Product catalog
            setup , Secure price integration , Shopping cart functionality ,
            Mobile optimization.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img className="icon-img" src={analytics} alt="Funnel Analytics" />
          </div>
          <h3>UI/UX Design Solutions</h3>
          <p>
            A visually attractive website alone isn't always sufficient. User
            enjoy performs a crucial position in consumer satisfaction and
            conversions. Our crew presents professional{" "}
            <b>ui ux design services</b> that improve usability, accessibility,
            and patron engagement.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img className="icon-img" src={testing} alt="A/B Testing" />
          </div>
          <h3>SEO-Friendly Website Design</h3>
          <p>
            Search engine optimization is incorporated into each internet site
            we create. From right structure to optimized content material and
            rapid performance, we ensure your website is prepared to compete in
            seek engine ratings.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={optimization}
              alt="Advanced Optimization"
            />
          </div>
          <h3>Landing Page Design</h3>
          <p>
            Our professional landing page design services help businesses
            generate leads, increase conversions, and improve marketing campaign
            performance. We create visually attractive, fast-loading, and
            conversion-focused landing pages that encourage visitors to take
            action and improve customer engagement.
          </p>
        </div>

        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={optimization}
              alt="Advanced Optimization"
            />
          </div>
          <h3>Website Maintenance Services</h3>
          <p>
            Our website maintenance services ensure your website remains secure,
            updated, and fully functional at all times. We provide regular
            updates, performance monitoring, bug fixes, security checks, and
            technical support to keep your website running smoothly and
            efficiently.{" "}
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={optimization}
              alt="Advanced Optimization"
            />
          </div>
          <h3>Website Redesign Services</h3>
          <p>
            Our website redesign services help businesses upgrade outdated
            websites with modern layouts, improved functionality, and better
            user experiences. We redesign websites to enhance performance,
            mobile responsiveness, SEO optimization, and conversion rates while
            maintaining your brand identity and business goals.
          </p>
        </div>
      </div>
    </div>
  );
};

export default UIservice;
